<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col cols="3">
        <v-card
          class="d-flex align-center justify-center text-center pa-3 add-platform-card"
          @click="addPlatforms"
          outlined
        >
          <div class="d-flex align-center">
            <v-icon small class="mr-2">fa-plus</v-icon>
            <h4 class="mb-0">{{ $t("addPlatform") }}</h4>
          </div>
        </v-card>
      </v-col>
      <v-col
        v-bind:key="linkedPlatform.id"
        v-for="linkedPlatform in linkedPlatforms"
        cols="3"
      >
        <v-card
          class="d-flex align-center justify-center pa-3 pt-1 text-center platform-card"
          outlined
        >
          <div>
            <div class="d-flex align-center justify-center">
              <v-img
                :src="getPlatformImage(linkedPlatform.platform.name)"
                max-height="27"
                max-width="27"
                contain
              />
              <h4 class="ml-1">{{ linkedPlatform.platform.name }}</h4>
            </div>
            <div
              v-if="
                Number(linkedPlatform.platform.lastVersion) >
                Number(linkedPlatform.version)
              "
              class="d-flex align-center justify-center"
            >
              <p class="mb-0 mt-2">
                V. {{ linkedPlatform.version }}
                <v-icon color="orange" class="mt-n1 mr-2" x-small
                  >fa-triangle-exclamation</v-icon
                >
                <v-chip
                  class="mt-n1"
                  @click="downloadLastVersion(linkedPlatform.platform)"
                  x-small
                  >{{ $t("downloadNewVersion") }}</v-chip
                >
              </p>
            </div>
            <p v-else class="mb-0 mt-1">
              {{ $t("version") }} {{ linkedPlatform.version }}
              <v-icon class="mt-n1" x-small>fa-check-circle</v-icon>
            </p>
            <p style="font-size: 14px; color: #6c7079" class="my-0">
              {{ getLastActivity(linkedPlatform) }}
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LinkedPlatformRepository from "../../../repositories/linkedPlatform";

export default {
  name: "LinkedPlatforms",
  data() {
    return {
      linkedPlatforms: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      LinkedPlatformRepository.allLinkedPlatformsOfUser().then((response) => {
        if (response.status < 400) this.linkedPlatforms = response.data;
      });
    },
    getPlatformImage(platform) {
      switch (platform) {
        case "NinjaTrader":
          return "https://i0.wp.com/sharpvisiontraders.com/wp-content/uploads/2024/01/NtLogoShort-Trans.png";
        case "MetaTrader 4":
          return "https://images.squarespace-cdn.com/content/v1/5d849fb37a733a2e699b3774/1588861945863-2ID74IHT0Y1VGKLYE497/Metatrader4?format=1000w";
        case "MetaTrader 5":
          return "https://images.squarespace-cdn.com/content/v1/5d849fb37a733a2e699b3774/1588861945863-2ID74IHT0Y1VGKLYE497/Metatrader4?format=1000w";
        case "MetaTrader Server":
          return "https://images.squarespace-cdn.com/content/v1/5d849fb37a733a2e699b3774/1588861945863-2ID74IHT0Y1VGKLYE497/Metatrader4?format=1000w";
        case "ATAS":
          return "https://atas.net/wp-content/uploads/2020/05/Logo-Original.png";
        case "cTrader":
          return "https://ctrader.com/bundles/ctraderctdn/img/ctrader_round-logo.png?v1.9.9";
        case "BinanceAPI":
          return "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Binance-coin-bnb-logo.png/1200px-Binance-coin-bnb-logo.png";
        default:
          return "https://www.zebra.com/es/es/services/signature-services/software-integration/_jcr_content/mainpar/columncontrol_d2ab/col1par/imagecomponent_3548/image.adapt.1280.png/1533647282046.png";
      }
    },
    getLastActivity(linkedPlatform) {
      let lastActivity = new Date(linkedPlatform.lastActivity);
      return `${this.$t("lastActivity")} ${String(
        lastActivity.getDate()
      ).padStart(2, "0")}/${String(lastActivity.getMonth() + 1).padStart(
        2,
        "0"
      )}/${String(lastActivity.getFullYear()).substr(2, 2)} ${String(
        lastActivity.getHours()
      ).padStart(2, "0")}:${String(lastActivity.getMinutes()).padStart(
        2,
        "0"
      )}`;
    },
    addPlatforms() {
      window.open(
        `https://swiset.com/${
          this.$i18n.locale === "en"
            ? "automated-journal"
            : "es/journal-automatico"
        }`
      );
    },
    downloadLastVersion(platform) {
      window.open(platform.downloadLink);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/global";

.theme--dark.app {
  .platform-card {
    background-color: #232830 !important;
  }
}

.platform-card {
  height: 110px !important;
  background-color: var(--v-mainWhite-base) !important;
}

.add-platform-card {
  height: 110px !important;
  border: 1px dashed $border-color !important;
  background-color: transparent;
}
</style>


